import _ from 'lodash';

export default function fitTextDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: fitTextDirectiveCtrl,
	};
}

class fitTextDirectiveCtrl {
	constructor($element, $scope) {
		'ngInject';
		this.element = $element[0];
		this.element.style.visibility = 'hidden';
		this.fit = _.throttle(this.fit.bind(this), 150, { leading: true, trailing: true });
		setTimeout(() => {
			this.startSize = parseFloat(window.getComputedStyle(this.element, null).getPropertyValue('font-size'));
			window.addEventListener('resize', this.fit);
			$scope.$watch(() => this.element.innerHTML, this.fit);
			this.fit();
		}, 50);
	}

	$onDestroy() {
		window.removeEventListener('resize', this.fit);
	}

	fit() {
		let size = this.startSize;
		this.element.style.overflow = 'scroll';
		while (true) {
			if (size <= 9) {
				break;
			} else if (
				this.element.scrollHeight <= this.element.clientHeight + 5 &&
				this.element.scrollWidth <= this.element.clientWidth + 5
			) {
				break;
			}
			size -= 2;
			this.element.style.fontSize = size + 'px';
		}
		// we split pixels sometimes so let it hang baby
		this.element.style.overflow = 'visible';
		this.element.style.visibility = 'visible';
	}
}
